import { Color, ComponentProps, ComponentRef, Components } from '../../../interface';
import { assignComponentProps } from '../../../utils/helpers';
import { getAppRoot } from '../../../utils/theme';

export interface ModalOpts {
  'animation'?: ('bottom' | 'right');
  'backdropDismiss'?: boolean;
  'color'?: Color;
  'colorHeaderInputs'?: Color;
  'colorIconSmall'?: Color;
  'colorValue'?: Color;
  'component'?: ComponentRef;
  'componentProps'?: ComponentProps;
  'headerSize'?: ('small' | 'default');
  'icon'?: string;
  'iconSmall'?: string;
  'mainTitle'?: string;
  'overlayIndex'?: number;
  'showBackdrop'?: boolean;
  'subTitle'?: string;
  'supTitle'?: string;
  'swipeGesture'?: boolean;
  'value'?: string;
  'valueTranslationValues'?: any;
  'onLarmodalwillpresent'?:() => void,
  'onLarmodaldidpresent'?: () => void
  'onLarmodalwilldismiss'?: () => void,
  'onLarmodaldiddismiss'?: () => void,
}

export async function createModal(opts: ModalOpts): Promise<HTMLLarModalElement> {
  if (typeof customElements !== 'undefined') {
    await customElements.whenDefined('lar-modal');
    const element = document.createElement('lar-modal') as HTMLLarModalElement;
    assignComponentProps(element, opts);
    // append the overlay element to the document body
    getAppRoot(document).appendChild(element);
    element.addEventListener('larmodaldiddismiss', () => {
        element.remove();
      })
    return element;
  }
  throw new Error('WebComponents not available');
};
